import { render, staticRenderFns } from "./claimedit_hangkongxian.vue?vue&type=template&id=94d587da&scoped=true&"
import script from "./claimedit_hangkongxian.vue?vue&type=script&lang=js&"
export * from "./claimedit_hangkongxian.vue?vue&type=script&lang=js&"
import style0 from "./claimedit_hangkongxian.vue?vue&type=style&index=0&id=94d587da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d587da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d587da')) {
      api.createRecord('94d587da', component.options)
    } else {
      api.reload('94d587da', component.options)
    }
    module.hot.accept("./claimedit_hangkongxian.vue?vue&type=template&id=94d587da&scoped=true&", function () {
      api.rerender('94d587da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimedit_hangkongxian.vue"
export default component.exports